module.exports = __webpack_public_path__ + "static/media/fan_mode.2edba1ee.png";